import { array, date, mixed, object, string } from "yup"
import bankModel from "../atoms/bank.model"
import kycModel from "../atoms/kyc.model"
// import { id } from "../common-properties";
import { email, firstName, ID, lastName, phoneNumber } from "../yup.common"
export default object({
  id: ID,
  firstName: firstName.required("First Name is Required!"),
  lastName: lastName.required("Last Name is required"),
  number: phoneNumber.required("Phone Number is required!"),
  username: string().min(3).required().label("Username"),
  email: email.label("Email"),
  dateOfBirth: date().label("Date Of Birth"),
  gender: string().label("Gender").nullable(),
  education: string().label("Education").nullable(),
  companies: array()
    .min(1, "Farmer should be assigned to atleast 1 company")
    .label("Companies"),
  secondaryNumber: string().label("Secondary Number").nullable(),
  group: mixed(),
  supplierType: mixed(),
  kycDetail: kycModel,
  bankDetail: bankModel,
})
